module.exports = __webpack_public_path__ + "img/whatsapp.07108ba3.svg";